/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/study-control.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { StudyControlAuditFields } from 'queries/generated/fragments.generated';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const StudyControlRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord =
        oldRecord && (oldRecord.ReviewFrequencyPeriod || oldRecord.reviewFrequencyUnits)
            ? {
                  ...oldRecord,
                  Phase: oldRecord.Phase === null ? undefined : oldRecord.Phase,
                  ReviewFrequencyPeriod: oldRecord.ReviewFrequencyUnits,
                  ReviewFrequencyUnits: oldRecord.ReviewFrequencyPeriod,
              }
            : { ...oldRecord, Phase: oldRecord.Phase === null ? undefined : oldRecord.Phase };
    const refactoredNewRecord =
        newRecord && (newRecord.ReviewFrequencyPeriod || newRecord.reviewFrequencyUnits)
            ? {
                  ...newRecord,
                  Phase: newRecord.Phase === null ? undefined : newRecord.Phase,
                  ReviewFrequencyPeriod: newRecord.ReviewFrequencyUnits,
                  ReviewFrequencyUnits: newRecord.ReviewFrequencyPeriod,
              }
            : { ...newRecord, Phase: newRecord.Phase === null ? undefined : newRecord.Phase };

    const enums: any = {
        ReviewFrequencyPeriod: AuditEnumValues.TimeFrequency,
        Phase: AuditEnumValues.ControlPhase,
    };

    const lookups: any = {
        ResponsibleFunctionId: (control: StudyControlAuditFields) => control?.responsibleFunction?.name,
        OwnerId: (control: StudyControlAuditFields) =>
            control?.owner ? `${control.owner.firstName} ${control.owner.lastName}` : '',
        TypeId: (control: StudyControlAuditFields) => control?.type?.name,
        ControlPhaseId: (control: StudyControlAuditFields) => control?.controlPhase?.name,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
            lookups,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { StudyControlRecordChangeGrid };
